import { MetaPixel } from '@novakid/frontend-core';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

import { CONFIG } from 'config';

export const useMetaPixel = () => {
  const location = useLocation();

  useEffect(() => {
    if (CONFIG.IS_DEV) return;
    MetaPixel.onPageView()
  }, [location]);
};